__turbopack_context__.v({
  "moreTripsButton": "upcoming-trips-home-module__6s_aLa__moreTripsButton",
  "upcomingTripsHeading": "upcoming-trips-home-module__6s_aLa__upcomingTripsHeading",
  "upcomingTripsListContent": "upcoming-trips-home-module__6s_aLa__upcomingTripsListContent",
});
